<template>
  <div class="preview">
    <div
      v-if="title"
      class="preview__title"
    >
      {{ title }}
    </div>
    <div class="preview__content">
      <div
        v-for="(file, idx) in files"
        :key="`${idx}-item`"
        class="preview__item"
      >
        <v-img
          v-if="file.type.startsWith('image')"
          :src="getFileUrl(file)"
          width="100"
          height="100"
          contain
          @click="openPreviewModal(file)"
        />
        
        <div
          v-if="file.type.startsWith('audio')"
          class="preview__item--text"
          @click="openPreviewModal(file)"
        >
          Аудио: {{ file.name }}
        </div>
        <div
          v-if="file.type.startsWith('video')"
          class="preview__item--text"
          @click="openPreviewModal(file)"
        >
          Видео: {{ file.name }}
        </div>
        <v-icon
          v-if="deletableFiles"
          class="icon-close"
          color="primary"
          @click="onDeleteFile(idx)"
        >
          mdi-close
        </v-icon>
      </div>
    </div>

    <m-preview-modal
      :preview-modal="previewModal"
      :file="selectedFile"
      @close="closePreviewModal"
    />
  </div>
</template>

<script>
import mPreviewModal from '@/components/widgets/m-preview-modal.vue'
import { getFileUrl } from "@/assets/helpers/getFileUrl";

export default {
  components: {
    mPreviewModal,
  },
  props: {
    files: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    deletableFiles: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      previewModal: false,
      selectedFile: {},
    }
  },
  methods: {
    getFileUrl,
    closePreviewModal() {
      this.previewModal = false
      this.selectedFile = {}
    },
    openPreviewModal(file) {
      this.selectedFile = file
      this.previewModal = true
    },
    onDeleteFile(idx) {
      this.$emit('delete-file', idx)
    }
  },
}
</script>

<style lang="scss" scoped>
.preview {

  &__content {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px;
  }
  &__item {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 100px;
    height: 100px;
    border: 1px solid $dark-gray-old;
    border-radius: 8px;

    &--text {
      padding: 5px;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;  
      overflow: hidden;
      word-wrap: break-word;
    }

    .icon-close {
      position: absolute;
      top: 0;
      right: 0;
      cursor: pointer;
    }
  }
}

</style>